export default {
  back: 'Powrót do kampanii',
  title: 'Kampania',
  sent_at: 'Wysłano {{time}}',
  breakdown_title: 'Podsumowanie dostarczenia',
  pending_receipts: {
    title: 'Statystyki dostarczenia są w drodze',
    description:
      'Ta kampania została właśnie wysłana. Dostawcy push potwierdzają dostarczenie około 15 minut po wysłaniu, więc dane poniżej pojawią się ok. {{time}} — nie wymaga działania.',
    countdown:
      'Apple i Google potwierdzają odbiór za ok. {{minutes}}m {{seconds}}s (ok. {{time}}). Statystyki odświeżą się automatycznie.',
    ready: 'Potwierdzenia powinny być dostępne. Dane poniżej są teraz odświeżane.',
    soon: 'wkrótce',
  },
  recipients: {
    title: 'Odbiorcy',
    subtitle: 'Do kogo wysłano tę kampanię i czy dotarła do urządzenia.',
    filters: {
      all: 'Wszyscy',
      delivered: 'Dostarczone',
      pending: 'Oczekuje na potwierdzenie',
      failed: 'Niedostarczone',
    },
    columns: {
      recipient: 'Odbiorca',
      status: 'Status',
      reason: 'Powód',
      clicked: 'Kliknięto',
      sent_at: 'Wysłano o',
    },
    status: {
      delivered: 'Dostarczone',
      pending: 'Oczekuje na potwierdzenie',
      failed: 'Niedostarczone',
    },
    reasons: {
      DeviceNotRegistered: 'Aplikacja usunięta lub powiadomienia wyłączone (wygasły token)',
      MessageRateExceeded: 'Tymczasowo ograniczone przez Expo',
      MessageTooBig: 'Zawartość powiadomienia jest zbyt duża',
      MismatchSenderId: 'Niezgodność danych uwierzytelniających push',
      InvalidCredentials: 'Nieprawidłowe dane uwierzytelniające push',
      batch_failed: 'Wysyłanie partii nie powiodło się',
      missing_ticket: 'Brak potwierdzenia od Expo',
      unknown: 'Nieznany błąd dostarczenia',
    },
  },
};
